<template>
  <header class="sticky top-0 z-40 border-b border-edge bg-night/90 backdrop-blur">
    <nav class="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2.5 sm:px-6">
      <RouterLink to="/" class="flex items-center gap-2.5 text-slate-100">
        <img src="../assets/logo.webp" alt="" class="h-9 w-9 rounded-full object-cover ring-2 ring-hippo" />
        <span class="font-display text-lg font-extrabold tracking-tight">Drunken Hippos</span>
      </RouterLink>

      <!-- Navigation (Desktop) -->
      <div class="hidden items-center gap-1 md:flex">
        <RouterLink
          v-for="link in links"
          :key="link.to"
          :to="link.to"
          class="rounded-xl px-3.5 py-2.5 text-[15px] font-medium text-slate-300 transition-colors hover:bg-panel hover:text-white"
          exact-active-class="bg-panel !text-white"
        >
          {{ link.label }}
        </RouterLink>
      </div>

      <!-- Burger Menu Button (mobil) -->
      <button
        @click="menuOpen = true"
        class="flex h-11 w-11 items-center justify-center rounded-xl border border-edge bg-panel md:hidden"
        aria-label="Menü öffnen"
        :aria-expanded="menuOpen"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
          <path d="M4 7h16M4 12h16M4 17h10" />
        </svg>
      </button>
    </nav>

    <!-- Seitenmenü (mobil) – per Teleport außerhalb des Headers, dessen backdrop-blur sonst fixed-Elemente auf Header-Höhe begrenzt -->
    <Teleport to="body">
      <transition name="fade">
        <div v-if="menuOpen" class="fixed inset-0 z-50 bg-black/60 md:hidden" @click="menuOpen = false"></div>
      </transition>
      <transition name="slide">
        <div
          v-if="menuOpen"
          class="fixed right-0 top-0 z-50 flex h-full w-72 max-w-[85vw] flex-col border-l border-edge bg-night md:hidden"
        >
          <div class="flex items-center justify-between px-4 py-2.5">
            <span class="font-display text-lg font-extrabold">Menü</span>
            <button
              @click="menuOpen = false"
              class="flex h-11 w-11 items-center justify-center rounded-xl border border-edge bg-panel"
              aria-label="Menü schließen"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="flex flex-col gap-1 px-4 py-2">
            <RouterLink
              v-for="link in links"
              :key="link.to"
              :to="link.to"
              class="rounded-xl px-4 py-3 text-base font-medium text-slate-300 transition-colors hover:bg-panel hover:text-white"
              exact-active-class="bg-panel !text-beer"
            >
              {{ link.label }}
            </RouterLink>
          </div>
        </div>
      </transition>
    </Teleport>
  </header>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const links = [
  { to: '/', label: 'Übersicht' },
  { to: '/rules', label: 'Regeln' },
  { to: '/impressum', label: 'Impressum' },
];

const menuOpen = ref(false);
const route = useRoute();

watch(() => route.fullPath, () => {
  menuOpen.value = false;
});
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.25s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
